import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import useScreenSize from '../../../hooks/useScreenSize';
import { SelectCategoryStepProps } from './types';
import { ItemCreationLayout } from '../ItemCreationLayout';
import { StepModalOptionText } from '../styled';
import { SelectCategoryOption, SelectCategoryOptionWrapper } from './styled';
import { Icon } from '../../Icon';
import {
  BUILDING_TYPE_ID,
  FORM_VALUES
} from '../../../utils/helpers/constants';
import { getFlattenCategories } from '../../../utils/helpers/search';
import { getCategoryValues } from '../../../utils/helpers/common';
import { Category } from '../../../graphql/graphql';
import { DealTypeTabs } from '../DealTypeTabs';
import { fillCategoriesWithData } from '../../../utils/helpers/fillCategoriesWithData';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';
import { useClient } from '../../../hooks/useClient';

const tabsStats = [
  {
    value: 'false',
    dataStat: 'create_ad_step2_mode_sell'
  },
  {
    value: 'true',
    dataStat: 'create_ad_step2_mode_rent'
  }
];

export const SelectCategoryStep: React.FC<SelectCategoryStepProps> = ({
  goNext,
  categories
}) => {
  const {
    i18n: { language }
  } = useTranslation();
  const { isSmall } = useScreenSize();
  const { change } = useForm();
  const isClient = useClient();

  const categoriesData = getFlattenCategories({
    data: categories as Category[] | undefined,
    language
  });
  const filledCategories = fillCategoriesWithData(categoriesData);

  const handleOptionClick = (category: (typeof filledCategories)[number]) => {
    const newCategoryId =
      category.id === BUILDING_TYPE_ID.FLAT_ALL
        ? BUILDING_TYPE_ID.FLAT_NEW
        : category.id;
    change(FORM_VALUES.categoryId, newCategoryId);
    change(FORM_VALUES.typeEstate, category.name);
    const categoryValues = getCategoryValues({
      id: category.id,
      categories: categories as Category[]
    });
    change(FORM_VALUES.categoryValues, categoryValues);
    goNext();
  };

  const iconSize = isSmall ? 30 : 38;

  return (
    <ItemCreationLayout
      cypress="category_modal"
      contentCypress="category-modal__content"
    >
      <DealTypeTabs dataStats={tabsStats} />

      <SelectCategoryOptionWrapper>
        {filledCategories.map(item => (
          <SelectCategoryOption
            key={item.id}
            onClick={() => handleOptionClick(item)}
            data-cy="category_modal--option"
            data-stat={generateDataStat(item.newAdFormStat, isSmall, isClient)}
          >
            <Icon
              IconComponent={item.icon}
              width={iconSize}
              height={iconSize}
              indent={false}
              color="#fff"
            />
            <StepModalOptionText tag="body_3">{item.name}</StepModalOptionText>
          </SelectCategoryOption>
        ))}
      </SelectCategoryOptionWrapper>
    </ItemCreationLayout>
  );
};
